// shared-lib/group-customization/reconcileGroupLinks.js
//
// Verify a group's links against its geometry WITHOUT moving anything: every
// member is pinned, so `resolveGroup` only rewrites never-verified rp
// offsets, stamps `verifiedAt`, and reports links the geometry cannot hold.
//
// Both `attachVanityLinks` and `attachKitchenSinkLinks` call this on the
// merged link list before writing, which means every server attach site —
// build_vanity, optimize_vanity, apply_accessory_swap, style_kitchen, the
// two post-processing passes, the model-swap hook — writes links that are
// born verified, with no per-site edits. A freshly emitted auto-link was
// computed from the same geometry, so its delta is ~0 and it is simply
// stamped; a surviving user link from before enforcement is the one that
// may be rewritten. See reference-docs/layout-relationships/overview.md §3.2.

const { resolveGroup } = require('./resolveGroup');

/**
 * @param {Object[]} groupObjects — one fixture group's world-space objects
 * @param {Object[]} links — the merged link list about to be stored
 * @param {Object} [opts] — `{ walls?, now? }`, forwarded to resolveGroup
 * @returns {{ objects: Object[], links: Object[], unsatisfied: Object[],
 *   warnings: Object[] }} `objects` is always the input, by reference.
 */
function reconcileGroupLinks(groupObjects, links, opts = {}) {
  const objects = Array.isArray(groupObjects) ? groupObjects : [];
  const res = resolveGroup(objects, links, {
    ...opts,
    pinnedIds: new Set(objects.map((o) => o && o.id).filter(Boolean)),
  });
  return {
    objects,
    links: res.links,
    unsatisfied: res.unsatisfied,
    warnings: res.warnings,
  };
}

module.exports = { reconcileGroupLinks };
